<div class="container-xs-height full-height">
  <div class="row-xs-height">
    <div class="col col-xs-height col-middle">
      <div class="error-container text-center">
        <h2 class="semi-bold">Browser is not supported</h2>
        <p>Google Chrome is the only supported browser at the time.</p>
      </div>
    </div>
  </div>
</div>
